import { ESRI_CENSUS_YEAR, ESRI_CURRENT_YEAR, ESRI_PROJECTION_YEAR } from '../constants/esriDataVintage';

// Utility function to convert table data to CSV format
export const convertToCSV = (schools, columns) => {
  if (!schools || schools.length === 0) return '';
  
  // First, deduplicate schools by UUID to prevent duplicate entries
  const uniqueSchools = schools.reduce((acc, school) => {
    if (!acc.some(existing => existing.uuid === school.uuid)) {
      acc.push(school);
    }
    return acc;
  }, []);
  
  // Define the exact CSV columns in the requested order
  const csvColumns = [
    { id: 'ncessch', label: 'NCES School ID' },
    { id: 'state_school_id', label: 'State School ID' },
    { id: 'name', label: 'School Name' },
    { id: 'teamName', label: 'Network' },
    { id: 'enrollment', label: '2024-25 Enrollment' },
    { id: 'population2024', label: `${ESRI_CURRENT_YEAR} Area population size` },
    { id: 'marketShare', label: `${ESRI_CURRENT_YEAR} Market share` },
    { id: 'expectedMarketShare', label: `${ESRI_CURRENT_YEAR} Expected Market Share` },
    { id: 'enrollment2019', label: '2019-20 Enrollment' },
    { id: 'enrollmentTrend', label: '2019 to 2024 Change in enrollment' },
    { id: 'population2020', label: `${ESRI_CENSUS_YEAR} Area population size` },
    { id: 'populationTrend', label: `${ESRI_CENSUS_YEAR} to ${ESRI_CURRENT_YEAR} Change in area student population` },
    { id: 'marketShare2020', label: `${ESRI_CENSUS_YEAR} Market share` },
    { id: 'marketShareTrend', label: `${ESRI_CENSUS_YEAR} to ${ESRI_CURRENT_YEAR} Change in market share` },
    { id: 'population2030', label: `${ESRI_PROJECTION_YEAR} Area population size` },
    { id: 'populationProjection', label: `${ESRI_CURRENT_YEAR} to ${ESRI_PROJECTION_YEAR} % change in area population size` },
    { id: 'enrollment2029', label: '2029 Enrollment projection size' }
  ];
  
  // Create header row
  const headerRow = csvColumns.map(column => `"${column.label}"`);
  
  // Create data rows
  const dataRows = uniqueSchools.map(school => {
    const rowData = csvColumns.map(column => {
      let cellValue;
      
      switch (column.id) {
        case 'ncessch':
          cellValue = school.ncessch || '';
          break;
        case 'state_school_id':
          cellValue = school.state_school_id || '';
          break;
        case 'name':
          cellValue = school.name || '';
          break;
        case 'teamName':
          cellValue = school.region || '';
          break;
        case 'enrollment':
          cellValue = school.enrollment?.current || '';
          break;
        case 'population2024':
          cellValue = school.population?.current || '';
          break;
        case 'marketShare':
          cellValue = school.market_share?.current 
            ? Math.round(school.market_share.current) + '%'
            : '';
          break;
        case 'expectedMarketShare':
          // Use pre-calculated expected market share from SchoolMetrics
          cellValue = school.expected_market_share 
            ? Math.round(school.expected_market_share) + '%'
            : '';
          break;
        case 'enrollment2019':
          cellValue = school.enrollment?.past || '';
          break;
        case 'enrollmentTrend':
          if (school.is_newer) {
            cellValue = 'New School';
          } else {
            cellValue = school.enrollment?.trend
              ? Math.round(school.enrollment.trend) + '%'
              : '';
          }
          break;
        case 'population2020':
          cellValue = school.population?.past || '';
          break;
        case 'populationTrend':
          cellValue = school.population?.trend
            ? Math.round(school.population.trend) + '%'
            : '';
          break;
        case 'marketShare2020':
          cellValue = school.market_share?.past 
            ? Math.round(school.market_share.past) + '%'
            : '';
          break;
        case 'marketShareTrend':
          if (school.is_newer) {
            cellValue = 'New School';
          } else {
            cellValue = school.market_share?.trend
              ? Math.round(school.market_share.trend) + '%'
              : '';
          }
          break;
        case 'population2030':
          cellValue = school.population?.future || '';
          break;
        case 'populationProjection':
          cellValue = school.population?.projection_trend
            ? Math.round(school.population.projection_trend) + '%'
            : '';
          break;
        case 'enrollment2029':
          cellValue = school.enrollment?.projected || '';
          break;
        default:
          cellValue = '';
      }
      
      // Escape quotes in cell values and wrap in quotes
      return `"${String(cellValue).replace(/"/g, '""')}"`;
    });
    
    return rowData.join(',');
  });
  
  // Combine header and data rows
  return [headerRow.join(','), ...dataRows].join('\n');
};

// Function to trigger CSV download
export const downloadCSV = (schools, columns, filename = 'portfolio-analysis.csv') => {
  const csvContent = convertToCSV(schools, columns);
  
  // Create a Blob containing the CSV data
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  
  // Create a download link and trigger the download
  const link = document.createElement('a');
  
  // Create object URL for the Blob
  const url = URL.createObjectURL(blob);
  
  link.href = url;
  link.setAttribute('download', filename);
  link.style.display = 'none';
  
  // Add link to the document, click it, and remove it
  document.body.appendChild(link);
  link.click();
  
  // Clean up
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};